import React from 'react';
import {Flex, Select, Slider} from "antd";

const marks = {
    0: 'Rank: 0',
    0.5: '0.5',
    0.9: '0.9'
};

const SettingsPanel = ({ settings, handleSettings }) => {

    const changeTypeSettings = (values) => handleSettings({ ...settings, type: values})

    const changeRankSettings = (rank) => handleSettings({ ...settings, rank})

    return (
        <Flex
            horizontal="true"
            style={{ padding: '10px 40px'}}
            justify="flex-start"
            align="center"
            gap={40}
        >
            <Select
                mode="multiple"
                allowClear
                style={{width: '50%',}}
                placeholder="Источники поиска"
                value={settings.type || ['index', 'vector']}
                onChange={changeTypeSettings}
                options={[
                    {
                        value: 'index',
                        label: 'Индексный поиск',
                    },
                    {
                        value: 'vector',
                        label: 'Векторный поиск',
                    },
                ]}
            />
            <Slider style={{width: '200px',}}
                min={0} max={0.9} step={0.1} marks={marks}
                onChangeComplete={changeRankSettings}
                defaultValue={typeof settings.rank === 'number' ? settings.rank : 0.5}
            />
        </Flex>
    )
};

export default SettingsPanel;
